import React from 'react';
import {
  commonFiltersFromParameters,
  formatTimecardReportStatusLabel,
} from '../utils/timecardReportFilters';

interface ReportRunCommonFilterDetailsProps {
  parameters: Record<string, unknown> | undefined | null;
}

const ReportRunCommonFilterDetails: React.FC<ReportRunCommonFilterDetailsProps> = ({ parameters }) => {
  const filters = commonFiltersFromParameters(parameters);

  return (
    <>
      <div>
        <dt className="text-neutral-500 text-xs uppercase tracking-wide">Timecard status</dt>
        <dd className="text-neutral-900">{formatTimecardReportStatusLabel(filters.statusFilter)}</dd>
      </div>
      <div>
        <dt className="text-neutral-500 text-xs uppercase tracking-wide">Schedules</dt>
        <dd className="text-neutral-900">
          {filters.scheduleLabels?.length ? filters.scheduleLabels.join(', ') : 'All'}
        </dd>
      </div>
      <div>
        <dt className="text-neutral-500 text-xs uppercase tracking-wide">Positions</dt>
        <dd className="text-neutral-900">
          {filters.positionLabels?.length ? filters.positionLabels.join(', ') : 'All'}
        </dd>
      </div>
      <div>
        <dt className="text-neutral-500 text-xs uppercase tracking-wide">Employees</dt>
        <dd className="text-neutral-900">
          {filters.employeeLabels?.length ? filters.employeeLabels.join(', ') : 'All'}
        </dd>
      </div>
    </>
  );
};

export default ReportRunCommonFilterDetails;
